import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Plus, ArrowLeft } from 'lucide-react';
import { DataTable } from '@/components/shared';
import { useNavigate } from 'react-router-dom';
import { RaceTypesManagerViewProps } from './racetypesmanager.props';
import RaceTypesFormDialog from './racetypesmanager.form';

const RaceTypesManagerView: React.FC<RaceTypesManagerViewProps> = ({
  raceName,
  embedded,
  raceTypes,
  loading,
  raceTypeColumns,
  isDialogOpen,
  setIsDialogOpen,
  editingRaceType,
  formData,
  setFormData,
  handleCreate,
  handleSubmit,
  deleteTarget,
  setDeleteTarget,
  confirmDelete,
}) => {
  const navigate = useNavigate();

  const content = (
    <>
      <Card>
        <CardHeader>
          <div className="flex items-center justify-between">
            <div>
              <CardTitle>Типови на трки за {raceName}</CardTitle>
              <p className="text-sm text-gray-600 mt-1">Управувајте со типовите на трки и нивните детали</p>
            </div>
            <Button onClick={handleCreate}>
              <Plus className="w-4 h-4 mr-2" />
              Додај тип на трка
            </Button>
          </div>
        </CardHeader>
        <CardContent>
          <DataTable columns={raceTypeColumns} data={raceTypes} loading={loading} emptyMessage="Нема креирано типови на трки. Додајте прв тип на трка." />
        </CardContent>
      </Card>
      <RaceTypesFormDialog
        isDialogOpen={isDialogOpen}
        setIsDialogOpen={setIsDialogOpen}
        editingRaceType={editingRaceType}
        formData={formData}
        setFormData={setFormData}
        handleSubmit={handleSubmit}
        deleteTarget={deleteTarget}
        setDeleteTarget={setDeleteTarget}
        confirmDelete={confirmDelete}
      />
    </>
  );

  if (embedded) {
    return content;
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <Button variant="ghost" onClick={() => navigate('/cms')} className="mb-6">
        <ArrowLeft className="w-4 h-4 mr-2" />
        Назад
      </Button>
      {content}
    </div>
  );
};

export default RaceTypesManagerView;
